export class Telework {
  public resourceId: string;
  public date: string;

  constructor(resourceId: string, date: string) {
    this.resourceId = resourceId;
    this.date = date;
  }
}
